<script>
import {
  getStatusDetail, OrderStatusNames
} from "@/core/constants/Orders.constants";

export default {
  name: "SiparisStatusChip",
  methods: { getStatusDetail },

  props: {
    value: {
      required: true,
      type: Number
    }
  },

  setup(props) {
    return {
      statusDetail: getStatusDetail(props.value)
    };
  }

};
</script>

<template>
  <div>
    <v-chip
      small
      class="font-weight-medium"
      :color="statusDetail.backgroundColor"
      :style="{ color: statusDetail.textColor }"
    >
      {{ statusDetail.statusText }}
    </v-chip>
  </div>
</template>

<style scoped>

</style>